import 'css-chunksrc/client/scenes/calendarHolidaysEdition/form/styles.scss';export default {
  "form": "_form_fv3qu_1",
  "group": "_group_fv3qu_9",
  "row": "_row_fv3qu_13",
  "horizontalRow": "_horizontalRow_fv3qu_24",
  "label": "_label_fv3qu_30",
  "description": "_description_fv3qu_36",
  "root": "_root_fv3qu_40",
  "listRoot": "_listRoot_fv3qu_44",
  "icon": "_icon_fv3qu_52",
  "input": "_input_fv3qu_61",
  "opened": "_opened_fv3qu_80",
  "list": "_list_fv3qu_44",
  "selected": "_selected_fv3qu_101",
  "option": "_option_fv3qu_105",
  "button": "_button_fv3qu_115"
};